import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-plus-circle",
  templateUrl: "./med-icon-plus-circle.component.html",
})
export class MedIconPlusCircleComponent extends SvgMixinComponent {}
